import BuyingGuide from './BuyingGuide.vue'

export default BuyingGuide
